// extracted by mini-css-extract-plugin
export default {"splitField":"szfZftcl9FD0Ll1MNDsF","inputContent":"pS3L5CgSnegiimhwlfzZ"};